
import { ChangeDetectionStrategy, Component, SimpleChanges } from '@angular/core';
import { CustomizerComponentHeaderComponent, CustomizerListComponent } from '@app/customizer/components';
import { VariantSizeFromApiModel } from '@models/variant-size-from-api';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationService } from '@services/configuration.service';
import { ImageService } from '@services/image.service';
import { ComponentCodeConstants } from '@shared/component-constants';
import { CustomizerStateConstants } from '@shared/customizer-state-constants';
import { FadeInOutTransition } from '@shared/transitions/fade-in-out.transition';
import { ComponentVariantModel } from '@models/component-variant';
import { VariantSizeModel } from '@models/variant-size';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ComponentVariantChangeModel } from '../../../../_models/component-variant-change';
import { SorterService } from '../../../../_services/sorter.service';
import { AngleConstants } from '../../../../shared/angle-constants';
import { BaseCustomizerComponent } from '../../../../shared/base-customizer-component';
@Component({
	selector: 'gemstone-size',
	templateUrl: 'gemstone-size.html',
	styleUrls: ['gemstone-size.scss'],
	animations: [
		FadeInOutTransition()
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CustomizerComponentHeaderComponent, CustomizerListComponent, TranslatePipe]
})

export class GemstoneSizeComponent extends BaseCustomizerComponent {
	public sizes: Array<VariantSizeFromApiModel | null> = [];
	public selectedSizeIndex: number = -1;
	public variantCode: string | null = null;
	public noneChoiceImage: string | null = null;
	public noneChoiceTranslation: string;
	public adjustMargin: boolean = false;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		private sorter: SorterService,
		private imageService: ImageService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	onChanges(changes: SimpleChanges): void {
	}

	async initData() {
		this.events.showLoader(true);
		this.adjustMargin = this.menu.parentMenu.translateName === ComponentCodeConstants.Nosepad;

		this.setImageSliderByName(AngleConstants.Perspective);
		this.sizes = await this.fetch() ?? [];
		this.noneChoiceImage = this.imageService.GetNoGemstoneImage(this.modelGroup.ProductLineCode);
		this.noneChoiceTranslation = `CUSTOMIZER.COMPONENTS.GEMSTONE.NOGEMSTONE`;
		if (this.variants.filter(v => v.Component.Code === ComponentCodeConstants.Gemstone)[0].Optional) {
			this.sizes.unshift(null);
		}
		if (this.getSelectedVariant.Optional && this.state !== CustomizerStateConstants.EDITORDER) {
			this.selectedSizeIndex = 0;
		} else {
			this.selectedSizeIndex = this.sizes.findIndex(x => x?.Uuid == this.getSelectedVariant.VariantSize?.Uuid);
		}
		this.events.showLoader(false);
	}

	onSizeSelect(index: number) {

		this.events.showLoader(true);
		this.selectedSizeIndex = index;

		const variantSize = this.sizes[index];

		const newVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const oldVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		newVariant.VariantSize = variantSize;
		const hasNoSize = variantSize === null;
		newVariant.NotSelected = hasNoSize;
		if (hasNoSize) {
			newVariant.VariantColor = null;
		}

		this.updateComponentSize(new ComponentVariantChangeModel(oldVariant, newVariant, null));
	}

	async fetch(): Promise<Array<VariantSizeFromApiModel> | undefined> {
		const variant = this.getSelectedVariant;
		variant.VariantSizeViewed = true;

		const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid);
		await this.RunDisablingSystem(apidata);
		const variantSizes = apidata?.[0].VariantSizes.sort(this.sorter.sortBy(VariantSizeModel));

		this.variantCode = apidata?.[0].Code ?? null;

		return variantSizes;
	}

	getImage = (variantSizeModel: VariantSizeModel) => {
		return this.imageService.GetComponentDetailPreciousImage(this.getSelectedVariant.Component.Code, this.variantCode, variantSizeModel, this.modelGroup.ProductLineCode);
	}
}
